import Header from "@/components//atoms/Header";
import ProductImage from "@/assets/images/product.png";
import { useQuizData } from "@/hooks/useQuizData";
import type { QuizSingleStep } from "@/types/api.types";

const OfferCoupon = ({ step }: { step: QuizSingleStep }) => {
  const { data } = useQuizData();
  const { productCoupon, options } = step ?? {};

  return (
    <div className="w-full mx-auto items-center flex flex-col">
      <span className="text-[24px] leading-[1.3333] font-semibold text-black mx-auto mb-6 text-center">
        {step?.recommendationLabel}
      </span>

      <div className="w-full mx-auto px-4 py-6 md:px-6 gap-4 md:gap-6 bg-[#DEF2FF] border-4 rounded-[10px] border-[#248AFF] flex flex-col items-center">
        <div className="w-auto max-h-6">
          <Header logoSrc={data?.settings?.logoUrl || ""} />
        </div>

        <span className="text-[20px] md:text-[24px] font-bold text-black text-center">
          {productCoupon?.heading}
        </span>

        <img
          src={productCoupon?.imageUrl || ProductImage}
          alt="Product Image"
        />

        <div className="flex flex-col items-center gap-0">
          <span className="text-[16px] text-[#828282] font-semibold line-through mb-2 leading-none">
            {productCoupon?.formattedOldPrice ?? "$174.98"}
          </span>
          <span className="text-[32px] text-[#009F32] font-bold mb-1 leading-none">
            {productCoupon?.formattedPrice ?? "$69.99"}
          </span>
          <span className="text-[18px] text-[#DB0000] font-semibold leading-[1.44444] text-center">
            {productCoupon?.saveLabel}
          </span>
        </div>

        <div className="flex flex-col items-center w-full">
          <a
            href={data?.settings?.nextLink?.url}
            className="bg-cta hover:bg-cta-hover rounded-[10px] mb-2 w-full max-w-[400px] p-4 text-center text-[16px] font-bold text-white"
          >
            {options?.[0]?.label}
          </a>
          <span className="text-[14px] text-[#666] text-center">
            {productCoupon?.moneyBackLabel}
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfferCoupon;
